export default __webpack_public_path__ + "static/media/bh6.a3d09b7c.jpg";